import React, { useContext, useEffect, useState } from "react";
import "./style.scss";
import Navbar from "../../components/navbar/Navbar";
import HomeWidget from "../../components/homeWidget/HomeWidget";
import Sidebar from "../../components/sidebar/Sidebar";
import { AuthContext } from "../../context/authContext/AuthContext";
import { MaterialsContext } from "../../context/materialsContext/MaterialsContext";
import { TasksContext } from "../../context/tasksContext/TasksContext";
import { SchedulesContext } from "../../context/schedulesContext/SchedulesContext";
import { DoubtsContext } from "../../context/doubtsContext/DoubtsContext";
import { getRecentMaterials } from "../../context/materialsContext/apiCalls";
import { getRecentTasks } from "../../context/tasksContext/apiCalls";
import { getRecentDoubts } from "../../context/doubtsContext/apiCalls";
import { getSchedules } from "../../context/schedulesContext/apiCalls";
import HeroSection from "../../components/heroSection/HeroSection";
import SubjectForm from "../../components/subjectForm/SubjectForm";
import axios from "axios";
import { FiTrash2 } from "react-icons/fi";
import { SubjectsContext } from "../../context/subjectsContext/SubjectsContext";
import { getSubjects } from "../../context/subjectsContext/apiCalls";
import Person from "@material-ui/icons/Person"; // Using existing MUI v4 icon to avoid version mismatch
import { Link } from "react-router-dom";

const Home = () => {
  const { user } = useContext(AuthContext);
  const { recentMaterials, dispatch: materialsDispatch } = useContext(MaterialsContext);
  const { recentTasks, dispatch: tasksDispatch } = useContext(TasksContext);
  const { schedules, dispatch: schedulesDispatch } = useContext(SchedulesContext);
  const { recentDoubts, dispatch: doubtsDispatch } = useContext(DoubtsContext);
  const { dispatch: subjectsDispatch } = useContext(SubjectsContext);

  // subject popup state
  const [isSubjectModalOpen, setSubjectModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("create");
  const [subjects, setSubjects] = useState([]);
  const [loadingSubjects, setLoadingSubjects] = useState(false);

  const fetchSubjects = async () => {
    try {
      setLoadingSubjects(true);
      const res = await axios.get(`/api/subject/all`, {
        headers: { token: `Bearer ${user?.accessToken}` },
      });
      setSubjects(res.data || []);
    } catch {
      // ignore
    } finally {
      setLoadingSubjects(false);
    }
  };

  const refreshGlobalSubjects = () => {
    if (user?.accessToken) getSubjects(user, subjectsDispatch);
  };

  const handleDeleteSubject = async (id) => {
    try {
      await axios.delete(`/api/subject/${id}`, {
        headers: { token: `Bearer ${user?.accessToken}` },
      });
      await fetchSubjects();
      refreshGlobalSubjects();
    } catch {
      // ignore
    }
  };

  useEffect(() => {
    if (recentMaterials?.length < 3 && user) getRecentMaterials(user, materialsDispatch);
  }, [recentMaterials?.length, materialsDispatch, user]);
  useEffect(() => {
    if (recentTasks?.length < 3 && user) getRecentTasks(user, tasksDispatch);
  }, [recentTasks?.length, tasksDispatch, user]);
  useEffect(() => {
    if (schedules?.length < 3 && user) getSchedules(user, schedulesDispatch);
  }, [schedules?.length, schedulesDispatch, user]);
  useEffect(() => {
    if (recentDoubts?.length < 3 && user) getRecentDoubts(user, doubtsDispatch);
  }, [recentDoubts?.length, doubtsDispatch, user]);

  useEffect(() => {
    if (isSubjectModalOpen) fetchSubjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubjectModalOpen]);

  return (
    <div className="home">
      <Navbar />
      <Sidebar />
      <div className="container">
        {(user.isTeacher || user.isAdmin) && (
          <div className="create-subject-section">
            <div className="subject-btn-wrapper">
              <div className="manage-reg-icon-btn-wrapper">
                <Link to="/registeredbyteacher" className="manage-reg-icon-btn" aria-label="Manage Registration">
                  <Person />
                </Link>
                <div className="manage-reg-tooltip">Manage Registration</div>
              </div>
              <button
                onClick={() => { setSubjectModalOpen(true); setActiveTab("create"); }}
                className="create-subject-icon-btn"
                aria-label="Create or delete subject"
              >
                +
              </button>
              <div className="subject-tooltip">Create New Subject</div>
            </div>

            {isSubjectModalOpen && (
              <div className="subject-form-overlay" onClick={() => setSubjectModalOpen(false)}>
                <div className="overlay-backdrop" />
                <div className="overlay-card" onClick={(e) => e.stopPropagation()}>
                  <button className="overlay-close" onClick={() => setSubjectModalOpen(false)} aria-label="Close">×</button>

                  <div className="subject-modal-tabs">
                    <button className={`tab ${activeTab === "create" ? "active" : ""}`} onClick={() => setActiveTab("create")}>Create</button>
                    <button className={`tab ${activeTab === "delete" ? "active" : ""}`} onClick={() => setActiveTab("delete")}>Delete</button>
                  </div>

                  {activeTab === "create" ? (
                    <SubjectForm onCreated={() => { setSubjectModalOpen(false); refreshGlobalSubjects(); }} />
                  ) : (
                    <div className="subject-list">
                      {loadingSubjects ? (
                        <div>Loading…</div>
                      ) : subjects?.length ? (
                        subjects.map((s) => (
                          <div key={s._id} className="subject-row">
                            <div className="name">{s.name} ({s.course} - {s.semester})</div>
                            <button className="subject-action-btn subject-delete-btn" onClick={() => handleDeleteSubject(s._id)}>
                              <FiTrash2 /> Delete
                            </button>
                          </div>
                        ))
                      ) : (
                        <div>No subjects</div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        <HeroSection large title="Welcome to WebDesk" />

        <div className="widgets-row">
          <HomeWidget
            title="Notes & Materials"
            type="materials"
            items={recentMaterials}
            link="/materials"
            itemList={recentMaterials}
          />
          <HomeWidget
            title="Tasks & Assignments"
            type="tasks"
            items={recentTasks}
            link="/tasks"
            itemList={recentTasks}
          />
        </div>

        <div className="widgets-row">
          <HomeWidget
            title="Class Schedule"
            type="schedules"
            items={schedules}
            link="/createclass"
            itemList={schedules}
          />
          <HomeWidget
            title="Doubts & Questions"
            type="doubts"
            items={recentDoubts}
            link="/doubts"
            itemList={recentDoubts}
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
